"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VendorModulesConfig = void 0;

var __1 = require("..");

var VendorModulesConfig =
/** @class */
function () {
  function VendorModulesConfig() {}

  VendorModulesConfig.loadVendorModulesFiles = function () {
    if (typeof isTestPaymentBrowser === "undefined" && typeof window !== "undefined") {
      require("../../../vendor_modules/vendor_modules");
    }

    VendorModulesConfig.verifyVendorModulesFilesLoaded();
  };

  VendorModulesConfig.verifyVendorModulesFilesLoaded = function () {
    if (typeof adyen === "undefined") {
      throw new __1.PaymentClientError("Cannot find vendor module, please make sure to load it", __1.PaymentErrorShortCodes.missing_vendor_library, {
        cause: {
          message: "adyen vendor module not loaded"
        }
      });
    }

    if (typeof forge === "undefined") {
      throw new __1.PaymentClientError("Cannot find vendor module, please make sure to load it", __1.PaymentErrorShortCodes.missing_vendor_library, {
        cause: {
          message: "forge module not loaded"
        }
      });
    }
  };

  return VendorModulesConfig;
}();

exports.VendorModulesConfig = VendorModulesConfig;


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/Configs/config.vendor_modules.js